import ApiClient from '@/api/api-client'

export default function() {
    return {
        getStudent: function() {
            return ApiClient.get('/student')
        },
        
        logout: function() {
            return ApiClient.get('/student/logout')
        }
    }
}
